import React, { useEffect, useState } from 'react';

function Press() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('https://fit-for-everybody-website.s3.us-east-2.amazonaws.com/press-page/press.json')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch press data');
        return res.json();
      })
      .then((data) => {
        setArticles(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error loading press data:', err);
        setLoading(false);
      });
  }, []);

  if (loading) return <p>Loading press articles...</p>;

  return (
    <div style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
      <h1 style={{ textAlign: 'center' }}>Press</h1>
      {articles.length === 0 && <p>No press articles available.</p>}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
        {articles.map((article, index) => (
          <div
            key={index}
            style={{
              border: '1px solid #ddd',
              borderRadius: '10px',
              padding: '15px',
              textAlign: 'center',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s',
            }}
            onMouseOver={(e) => (e.currentTarget.style.transform = 'scale(1.03)')}
            onMouseOut={(e) => (e.currentTarget.style.transform = 'scale(1)')}
          >
            {article.image && (
              <img
                src={article.image}
                alt={article.title}
                style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '8px' }}
              />
            )}
            <h3 style={{ marginTop: '10px', fontSize: '1.1em' }}>
              <a href={article.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: '#333' }}>
                {article.title}
              </a>
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Press;

